module.exports = __webpack_public_path__ + "assets/layer.eb09257e.svg";